import React, { Component } from "react";
// import OwlCarousel from 'react-owl-carousel';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Beach from '../assets/image/lombok/pantai1.jpg';
import Beach1 from '../assets/image/lombok/pantai2.jpeg';
import Rinjani from '../assets/image/lombok/rinjani.jpg';
import Pekalongan from '../assets/image/lombok/pekalongan.jpg';
import Pekalongan2 from '../assets/image/lombok/pekalongan2.jpg';
// var Carousel = require('react-responsive-carousel').Carousel;
class Gallery extends Component {
  state = {
    activeSilde: 0
  };

  handleSlideSelect = () => {};

  render() {
    const responsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
      tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 }
    };

    const CustomDot = ({ onMove, index, onClick, active }) => {
      // onMove means if dragging or swiping in progress.
      // active is provided by this lib for checking if the item is active or not.
      return (
        <li
          className={active ? "active" : "inactive"}
          onClick={() => onClick()}
        >
        </li>
      );
    };

    // const CustomRight = ({ onClick }) => (
    //   <button className="arrow right" onClick={onClick}>
    //     Right
    //   </button>
    // );
    // const CustomLeft = ({ onClick }) => (
    //   <button className="arrow left" onClick={onClick}>
    //     Left
    //   </button>
    // );
    //Also please improve the dot problem
    // Here we used number to just know click event buthelp us with ui too

    return (
      // <!-- Main Carousel Section Start -->
      <div id="photo" className="carousel slide bg-gray-wedlist" data-ride="carousel">
        <div className="text-base text-5xl text-center pt-16 pb-10 font-Alexs text-white">
          My Gallery
        </div>
        <div className="carousel-inner max-w-6xl mx-auto pb-24">
          <Carousel
            responsive={responsive}
            additionalTransfrom={0}
            arrows
            autoPlaySpeed={3000}
            centerMode={false}
            className=""
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            showDots
            sliderClass=""
            slidesToSlide={1}
            swipeable
            customDot={<CustomDot />}
            // customRightArrow={<CustomRight />}
            // customLeftArrow={<CustomLeft />}
          >
            <div className="carousel-item h-96 active grid justify-items-center">
              <img
                className="d-block max-w-2xl"
                src={Beach}
                alt="First slide"
              />
            </div>
            <div className="carousel-item h-96 active grid justify-items-center">
              <img
                className="d-block max-w-2xl"
                src={Beach1}
                alt="Second slide"
              />
            </div>
            <div className="carousel-item h-96 active grid justify-items-center">
              <img
                className="d-block max-w-2xl"
                src={Rinjani}
                alt="Third slide"
              />
            </div>
            <div className="carousel-item h-96 active grid justify-items-center">
              <img
                className="d-block max-w-2xl"
                src={Pekalongan}
                alt="Four slide"
              />
            </div>
            <div className="carousel-item h-96 active grid justify-items-center">
              <img
                className="d-block max-w-2xl"
                src={Pekalongan2}
                alt="Five slide"
              />
            </div>
          </Carousel>
        </div>
      </div>
      /* <!-- Main Carousel Section End --> */
    );
  }
}

export default Gallery;
